export default "__VITE_ASSET__D5DdVx5A__"